import { Loader2 } from "lucide-react";

export function LoadingState() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="relative">
        {/* Background Elements */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-[-50%] left-[-50%] w-64 h-64 bg-vaseline-pink rounded-full filter blur-3xl animate-float" />
          <div className="absolute bottom-[-50%] right-[-50%] w-72 h-72 bg-vaseline-blue rounded-full filter blur-3xl animate-float2" />
        </div>

        <div className="flex flex-col items-center gap-4 animate-fade-in relative z-10">
          <div className="relative">
            <div className="absolute inset-0 bg-vaseline-pink/20 blur-xl animate-pulse rounded-full" />
            <Loader2 className="h-12 w-12 animate-spin text-vaseline-white relative z-10" />
          </div>
          <div className="text-2xl font-medium text-vaseline-white animate-pulse">
            Loading tips...
          </div>
        </div>
      </div>
    </div>
  );
}